export const Conditional: React.FC<{
  isVisible: boolean;
  children: React.ReactElement;
}> = ({ isVisible, children }) => (isVisible ? children : null);
